module.exports = __webpack_public_path__ + "static/media/default_product.3b54a57d.svg";